<template>
  <div class="admin-pages">
    <PageTitle
      icon="fa fa-cogs"
      main="Adminstração do Sistema"
      sub="Cadastros \ Usuários \ Grupos \ Menus"
    />

    <div class="admin-pages-tabs">
      <b-card no-body>
        <b-tabs>
          <b-tab title="Menus"><CategoryAdmin /></b-tab>
          <b-tab title="Atualizações"><ArticleAdmin /></b-tab>
          <b-tab title="Usuários" active><UserAdmin /></b-tab>
          <b-tab title="Liberar"><LiberarAcessoGrupo /></b-tab>
          <b-tab title="Reconhecimento facial"><ReconhecimentoFacial /></b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import ArticleAdmin from "./ArticleAdmin"; //Atualizações
import CategoryAdmin from "./CategoryAdmin"; //Menus
import LiberarAcessoGrupo from "../admin/InformativaAcessoPorGrupoUsuarios";
import ReconhecimentoFacial from "../admin/ReconhecimentoFacial";
import UserAdmin from "./UserAdmin";

export default {
  name: "AdminPages",
  components: {
    PageTitle,
    ArticleAdmin,
    CategoryAdmin,
    UserAdmin,
    LiberarAcessoGrupo,
    ReconhecimentoFacial,
  },
};
</script>

<style>
</style>
